import { render, staticRenderFns } from "./Scan-In.vue?vue&type=template&id=4b986e49"
import script from "./Scan-In.vue?vue&type=script&lang=js"
export * from "./Scan-In.vue?vue&type=script&lang=js"
import style0 from "./Scan-In.vue?vue&type=style&index=0&id=4b986e49&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports